import useStore from 'store'
import { createRouter, createWebHistory, Router } from 'vue-router'
import routes from './routes'
import { useState } from 'modules/auth/store/state'

const router: Router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const store = useStore()
  const state = useState()

  
  const allowedDocsDomains = ['stage.documentation.tssinfohub.com', 'documentation.tssinfohub.com']
  const isDocumentation = allowedDocsDomains.includes(window.location.hostname)
  if (isDocumentation) {
    store.dashboard.setIsSBOpen(false)
    return next()
  } 

  if (to.meta.requiresAuth && !state.isAuthenticated && to.path !== '/login') {
    next('/login')
  } else if (state.isAuthenticated && to.path === '/login') {
    next('/dashboard')
  } else {
    next()
  }
  store.dashboard.setIsSBOpen(false)
})

export default router
